function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';
import { hideRightSidebar } from "../../redux/layout/actions";

class RightSideBar extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "rightBarNodeRef", void 0);

    _defineProperty(this, "componentDidMount", () => {
      document.addEventListener('mousedown', this.handleOtherClick, false);
    });

    _defineProperty(this, "componentWillUnmount", () => {
      document.removeEventListener('mousedown', this.handleOtherClick, false);
    });

    _defineProperty(this, "handleClose", e => {
      e.preventDefault();
      this.props.hideRightSidebar();
    });

    _defineProperty(this, "handleOtherClick", e => {
      if (this.rightBarNodeRef.contains(e.target)) return; // else hide the right sidebar

      this.props.hideRightSidebar();
    });

    this.handleClose = this.handleClose.bind(this);
    this.state = {};
  }
  /**
   *
   */


  render() {
    const title = this.props.title;
    const component = this.props.children || null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleBar, {
      style: {
        maxHeight: '100%',
        zIndex: 10000
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "right-bar",
      ref: node => this.rightBarNodeRef = node
    }, /*#__PURE__*/React.createElement("div", {
      className: "rightbar-title"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "#",
      className: "right-bar-toggle float-right",
      onClick: this.handleClose
    }, /*#__PURE__*/React.createElement("i", {
      className: "dripicons-cross noti-icon"
    })), /*#__PURE__*/React.createElement("h5", {
      className: "m-0"
    }, title)), /*#__PURE__*/React.createElement("div", {
      className: "rightbar-content"
    }, component))), /*#__PURE__*/React.createElement("div", {
      className: "rightbar-overlay"
    }));
  }

}

_defineProperty(RightSideBar, "defaultProps", {
  title: 'Right Sidebar'
});

export default connect(null, {
  hideRightSidebar
})(RightSideBar);